import { ReactNode } from "react";

import IllustrationLayout from "layouts/authentication/components/IllustrationLayout";

interface CoverLayoutProps {
  children: ReactNode;
  maxWidth?: number | string;
}

function CoverLayout({ children, maxWidth = 520 }: CoverLayoutProps): React.JSX.Element {
  return <IllustrationLayout maxWidth={maxWidth}>{children}</IllustrationLayout>;
}

export default CoverLayout;
